import styled from 'styled-components';
export const Container = styled.div `
    position: absolute;
    border-radius: 4px 4px 0px 0px;
    background: rgb(62, 61, 64);
`;
export const Time = styled.p `
    margin: 0 8px;
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
`;
//# sourceMappingURL=index.js.map